// extracted by mini-css-extract-plugin
export default {"container":"ImagePreview_container__CwIRC"};